angular.module('bmsApp.settings')
	.factory('SMJobCleaningServiceSvc', [
		'CRUDSvc',
		function (CRUDSvc) {

	return {
		index: function (params) {
			return CRUDSvc.get('api/sm/job/cleaning-service/index', params);
		},
	}
}]);




